// extracted by mini-css-extract-plugin
module.exports = {"item":"TeamList__item__3Gq_x","name":"TeamList__name__1hKAw"};